/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/8/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl';
import {Grid} from "@scuf/common";
import * as Faults from "../api/Faults";
import {fetchFleetManagers} from "../api/Users";
import * as Airtime from "../api/Airtime"
import {CURRENT_FAULT_STATES, FAULT_SORT, FAULT_STATES} from "../faults/common/FaultsConst";
import Loader from "../common/Loader";
import FaultsFilter from "../faults/list/FaultsFilter";
import FaultsListExpandable from "./FaultsListExpandable";
import CorruptionModal from "../common/CorruptionModal";
import {checkCorruptionOfDatabases} from "../api/AppConfigs";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {verifyAirtimeException} from "../utils/Helpers";
import {bindActionCreators} from "redux";
import * as SecurityActions from "../security/SecurityActions";
import ReportCreator from "../faults/list/ReportCreator";

class WorkerDashboard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            search: '',
            sort: FAULT_SORT.MODIFIED,
            engine: '',
            assignedFaults: [],
            unassignedFaults: [],
            fleetManagers: [],
            faultStatesCount: null,
            databaseCorruptionResult: null,
            closeCorruptionModal: false,
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Faults,
        }

        this.engineChanged = this.engineChanged.bind(this)
        this.searchChanged = this.searchChanged.bind(this)
        this.sortChanged = this.sortChanged.bind(this)
    }

    componentDidMount() {
        this.fetchData()
        this.checkCorruptionOfDatabase();
        fetchFleetManagers().then((data) => {
            this.setState({fleetManagers: data})
        })
    }

    checkCorruptionOfDatabase() {
        checkCorruptionOfDatabases().then((data) => {
            if (data != null && data.user != null && data.logString != null) {
                this.setState({databaseCorruptionResult: data, closeCorruptionModal: true})
            }
        })
    }

    fetchData() {
        this.setState({loading: true})
        this.state.apiPoint.fetchFaultsWithoutPagination([FAULT_STATES.NEW, FAULT_STATES.IN_PROGRESS, FAULT_STATES.ON_HOLD, FAULT_STATES.VERIFICATION,
                FAULT_STATES.CLOSED_RESOLVED, FAULT_STATES.NEW_ALERT, FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT,
                FAULT_STATES.CLOSED_DUE_TO_INACTIVITY],
            this.state.search, this.state.sort, null, this.props.userProfile.id).then((pageableResponse) => {
            this.setState({assignedFaults: pageableResponse.results, loading: false})
            //compute fault states count once
            if (!this.state.faultStatesCount) {
                const faultStatesCount = {}
                pageableResponse.results.forEach(f => {
                    // Fault with name starting 'Alert#' and with NEW state will be on UI shown with state 'NEW_ALERT' (this state doesn't really exist in DB)
                    const state = f.faultConditionState === FAULT_STATES.NEW && f.name.startsWith('Alert#') ? FAULT_STATES.NEW_ALERT : f.faultConditionState;
                    if (!faultStatesCount[state]) {
                        faultStatesCount[state] = 0
                    }
                    faultStatesCount[state] += 1
                })
                this.setState({faultStatesCount: faultStatesCount})
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
        this.state.apiPoint.fetchFaultsWithoutPagination([FAULT_STATES.NEW, FAULT_STATES.IN_PROGRESS, FAULT_STATES.ON_HOLD, FAULT_STATES.VERIFICATION],
            this.state.search, this.state.sort, null, -1)
            .then((pageableResponse) => this.setState({unassignedFaults: pageableResponse.results}))
            .catch(ex => verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut))
    }

    searchChanged(search) {
        this.setState({search: search}, this.fetchData)
    }

    engineChanged(engine) {
        this.setState({engine: engine}, this.fetchData)
    }

    sortChanged(sort) {
        if (sort !== this.state.sort) {
            this.setState({sort: sort}, this.fetchData)
        }
    }

    getFaultsStats() {
        if (!this.state.faultStatesCount) {
            return null
        }

        const attrs = []
        CURRENT_FAULT_STATES.forEach(s => {
            attrs.push(this.getAttributeRow('faults-' + s, this.state.faultStatesCount[s] || 0))
        })
        return attrs
    }

    getAttributeRow(key, value, cls) {
        const {intl} = this.props
        const name = intl.formatMessage({id: 'dashboard.attr.' + key})
        return <div key={key} className={"attr " + key + (cls ? (' ' + cls) : '')}><span className="attr-name">{name}: </span><span className="attr-value">{value}</span></div>
    }

    render() {
        const {intl} = this.props

        const assignedOpenFaults = this.state.assignedFaults.filter(f =>
            f.faultConditionState === FAULT_STATES.IN_PROGRESS
            || f.faultConditionState === FAULT_STATES.ON_HOLD
            || f.faultConditionState === FAULT_STATES.VERIFICATION
            || f.faultConditionState === FAULT_STATES.NEW)

        return (
            <div>
                <CorruptionModal
                    open={this.state.closeCorruptionModal}
                    onClose={() => {this.setState({closeCorruptionModal: false})}}
                    databaseCorruptionResult={this.state.databaseCorruptionResult}
                />
                <Loader loading={this.state.loading}/>
                <ReportCreator setLoading={() => this.setState({loading: true})}/>

                {/* Assigned faults block */}
                <h3>{intl.formatMessage({id: "dashboard.faults.assigned"}) + ' ' + '(' + assignedOpenFaults.length + ')'}</h3>
                <FaultsFilter sort={this.state.sort} sortOptions={FAULT_SORT} sortChanged={this.sortChanged}
                              searchChanged={this.searchChanged}/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <FaultsListExpandable faults={assignedOpenFaults}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkerDashboard)))
